<template>
    <b-container fluid style="padding:10px">
        <b-jumbotron header="Blog">
            Things I write about
        </b-jumbotron>

        <b-row align-content center>
            <b-col md="6">
                <b-card
                        title="Learnings from Techstars"
                        img-src="https://images.unsplash.com/photo-1617469955236-7f13d137a4f0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=100"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 project mx-auto"
                >
                    <b-card-text>
                        Learnings from my time and experience working with Techstars Founders
                    </b-card-text>

                    <b-button to="/blog-ts/" variant="primary">Read Techstars</b-button>
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card
                        title="Lifestyle + Travel"
                        img-src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 project mx-auto"
                >
                    <b-card-text>
                        Ramblings from my travels and personal journey
                    </b-card-text>

                    <b-button align="center" href="" variant="primary">Read Lifestyle</b-button>
                </b-card>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    export default {
        name: "Blog"
    }
</script>